<script lang="ts" setup>

definePageMeta({layout: "home-design"});

const route = useRoute();
const router = useRouter();
const path = route.params.slug.toString();
const post: any = await usePostUri(path);

</script>
<template>
    <section>
        <div class="articles-div-wrapper container-xl">
            <div class="section-spacer-lg"></div>

            <div class="articles-action d-flex justify-content-between align-items-center">
                <div class="articles-tags d-md-flex d-none">
                    <div class="tag-div" v-for="category in post?.categories?.nodes">
                        <span class="tag text-green-light">
                            {{ category?.name }}
                        </span>
                    </div>
                </div>
                <div class="action">
                    <a href="#" class="btn btn-white rounded-pill text-uppercase with-border" @click.prevent="() => router.back()">
                        Back to insights
                    </a>
                </div>
            </div>

            <div class="section-spacer-sm"></div>
            <div class="articles-tags d-md-none d-flex mb-2">
                <div class="tag-div" v-for="category in post?.categories?.nodes">
                    <span class="tag text-green-light">
                        {{ category?.name }}
                    </span>
                </div>
            </div>
            <div class="article-title d-flex flex-md-row flex-column justify-content-between align-items-md-center align-items-start">
                <h1 class="text-dark-2 mb-0 mb-md-2">{{ post?.title }}</h1>
                <span class="text-green-light article-date">{{ new Date(post?.date).toLocaleDateString('en-GB') }}</span>
            </div>
            <div class="section-spacer-sm"></div>
            <article class="wp-post-content text-dark-2" v-html="post?.content"></article>
        </div>
        <div class="section-spacer-sm"></div>
        <RelatedPost :categories="post?.categories?.nodes" :postDatabaseId="post?.databaseId"/>
        <div class="section-spacer"></div>
        <Newsletter :isEnabled="true"/>
    </section>
</template>